/* Přednačítání odkazů (prefetch) při najetí myší nebo doteku.

   Nahrazuje assets/tiny-img-link-preloader.js, což byl minifikovaný
   instant.page zapsaný do theme aplikací TinySEO. Chování je stejné, ale
   kód je čitelný a hlavně má VÝSLOVNÝ seznam cest, které se přednačíst nesmí.

   ⚠️ PROČ TEN SEZNAM: prefetch je skutečný GET požadavek, ne pouhá příprava.
   U adres, které mění stav relace, by ho tedy pouhé najetí myší vykonalo —
   /discount/<kód> zapisuje kupón do relace návštěvníka a /cart/add přidává
   zboží. Původní skript se spoléhal jen na to, že takové odkazy mají otazník
   (adresy s dotazem nepřednačítal). To u nás náhodou platí — tlačítko akce
   vede na /discount/KLOKIDAYS?redirect=… — ale je to shoda okolností, ne
   pravidlo: stačilo by jednou napsat odkaz bez parametru.

   Nepřednačítá: cizí domény, adresy s dotazem, cesty ze seznamu níž,
   odkazy s data-no-instant, a nic při zapnutém úsporném režimu nebo na 2G. */
(function () {
  var ZAKAZANE = ['/cart', '/checkout', '/account', '/discount/', '/apps/', '/services/', '/tools/'];
  var s = navigator.connection || {};
  if (s.saveData) return;
  if (s.effectiveType && /(^|-)2g$/.test(s.effectiveType)) return;

  var link = document.createElement('link');
  if (!(link.relList && link.relList.supports && link.relList.supports('prefetch'))) return;
  link.rel = 'prefetch';

  var cil = null, casovac = null, poslednidotek = 0;

  function lze(a) {
    if (!a || !a.href || a.href === cil) return false;
    if ('noInstant' in a.dataset) return false;
    var u;
    try { u = new URL(a.href); } catch (e) { return false; }
    if (u.origin !== location.origin) return false;
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
    if (u.search) return false;
    if (u.hash && u.pathname === location.pathname) return false;
    for (var i = 0; i < ZAKAZANE.length; i++) {
      if (u.pathname.indexOf(ZAKAZANE[i]) !== -1) return false;
    }
    return true;
  }

  function nacti(url) { cil = url; link.href = url; if (!link.parentNode) document.head.appendChild(link); }
  function stop() { cil = null; link.removeAttribute('href'); }

  document.addEventListener('mouseover', function (e) {
    if (performance.now() - poslednidotek < 1100) return;
    var a = e.target.closest && e.target.closest('a');
    if (!lze(a)) return;
    a.addEventListener('mouseout', function once() {
      a.removeEventListener('mouseout', once);
      clearTimeout(casovac); casovac = null; stop();
    });
    casovac = setTimeout(function () { nacti(a.href); casovac = null; }, 65);
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    poslednidotek = performance.now();
    var a = e.target.closest && e.target.closest('a');
    if (lze(a)) nacti(a.href);
  }, { capture: true, passive: true });
})();
